<template>
  <v-card class="my-4">
    <v-card-title class="card-title-variations"> Exibição </v-card-title>
    <v-row class="px-8">
      <v-divider></v-divider>
    </v-row>
    <v-card-text class="card-exhibition px-10">
      <v-row>
        <v-col cols="12">
          <h3 class="ma-0">Prioridade</h3>
          <p class="mt-0 texto-corrido">
            Selecione a prioridade em que o produto irá aparecer nos carrosséis do e-commerce. Quanto mais alta, o produto aparece a frente nas listagens.
          </p>
          <v-radio-group v-model="productForms.order">
            <v-radio label="Altíssima" :value="1" />
            <v-radio label="Alta" :value="2" />
            <v-radio label="Média" :value="3" />
            <v-radio label="Padrão" :value="99" />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProductStoreExhibition',
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    eanError() {
      return false
    },
  },
  watch: {},
  methods: {},
}
</script>

<style lang="scss"></style>
